/* tslint:disable */
type Unit =
  'CURRENCY' |
  'PERCENT' |
  'NUMBER' |
  'DURATION';
const Unit = (() => {
  const CURRENCY: Unit = 'CURRENCY';
  const PERCENT: Unit = 'PERCENT';
  const NUMBER: Unit = 'NUMBER';
  const DURATION: Unit = 'DURATION';
  function values(): Unit[] {
    return [
      CURRENCY,
      PERCENT,
      NUMBER,
      DURATION
    ];
  }
  return { CURRENCY, PERCENT, NUMBER, DURATION, values };
})();

export { Unit }
